import {TextField as MuiTextField} from "@mui/material";

const TextField = ({config, value, onChange, onEnter, size}) => (
  <MuiTextField
    label={config.label}
    placeholder={config.placeholder}
    size={size}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    onKeyDown={(e) => e.key === "Enter" && onEnter?.()}
    sx={{minWidth: config.width ?? 200}}
  />
);

export default TextField;
